<template>
  <div class="tx-orderhistory--list" v-if="orderlist.items.length">
    <div class="list-wrapper">
      <div class="list__header">
        <div class="header__label">
          <span>{{ $t('date') }}</span>
        </div>
        <div class="header__label">
          <span>{{ $t('number') }}</span>
        </div>
        <div class="header__label -small">
          <span>{{ $t('total') }}</span>
        </div>
        <div class="header__label">
          <span>{{ $t('state') }}</span>
        </div>
        <div class="header__label">
          <span>{{ $t('actions') }}</span>
        </div>
      </div>
      <div class="list__body">
        <div class="order-wrapper" v-for="(element, index) in orderlist.items" :key="index">
          <div class="order__value"><span>{{element.created_at}}</span></div>
          <div class="order__value"><span class="lnk" @click="openDetail(element)"><span class="">{{element.number}}</span></span></div>
          <div class="order__value -small"><span>{{$n(element.total, element.order_currency, element.order_locale)}}</span></div>
          <div class="order__value">
            <span class="state blue" v-if="element.state === 'synced'">{{ $t('synced') }}</span>
            <span class="state blue" v-if="element.state === 'processing'">{{ $t('processing') }}</span>
            <span class="state red" v-if="element.state === 'new'">{{ $t('new') }}</span>
            <span class="state red" v-if="element.state === 'cancelled'">{{ $t('cancelled') }}</span>
            <span class="state green" v-if="element.state === 'fulfilled'">{{ $t('fulfilled') }}</span>
            <span class="state grey" v-if="element.state === 'cart'">{{ $t('cart') }}</span>
          </div>
          <div class="order__value"><span class="lnk" @click="openDetail(element)" v-if="element.number"><span class="bold -color-alpha">{{ $t('show') }}</span><span class="mobile-icon icon-caret-right-after"></span></span></div>
        </div>
      </div>
    </div>
    <div class="order-history-overlay" :class="{'-show': orderlist.item && Object.keys(orderlist.item) && orderlist.item.number && globals.showOverlay}">
      <div class="overlay__bg" @click="globals.showOverlay = false"></div>
      <div class="module-overlay">
        <div class="overlay__close"><span class="icon-close-after" @click="globals.showOverlay = false"></span></div>
        <div class="overlay__content">
          <div class="content__basic">
            <div class="basic__number">
              <span class="heading beta">{{ $t('order') }}: {{orderlist.item.number}}</span>
            </div>
            <div class="basic__meta">
              <span>{{orderlist.item.created_at}}</span> |
              <span class="state blue" v-if="orderlist.item.state === 'synced'">{{ $t('synced') }}</span>
              <span class="state blue" v-if="orderlist.item.state === 'processing'">{{ $t('processing') }}</span>
              <span class="state red" v-if="orderlist.item.state === 'new'">{{ $t('new') }}</span>
              <span class="stater red" v-if="orderlist.item.state === 'cancelled'">{{ $t('cancelled') }}</span>
              <span class="state green" v-if="orderlist.item.state === 'fulfilled'">{{ $t('fulfilled') }}</span>
              <span class="state grey" v-if="orderlist.item.state === 'cart'">{{ $t('cart') }}</span> |
              <span>{{ orderlist.item.order_currency }}</span>
            </div>
          </div>
          <div class="content__address">
            <div class="content__shipping_address content__box" v-if="orderlist.item.shipping_address">
              <div class="content__header">
                <span class="heading delta">{{ $t('shippingHeadline') }}</span>
              </div>
              <div class="content__line">
                <span>{{orderlist.item.shipping_address.firstName}} {{orderlist.item.shipping_address.lastName}}</span><br>
                <span v-if="globals.otherOrderForAddress == 'false'">{{orderlist.item.shipping_address.street}} {{orderlist.item.shipping_address.houseNumber}} {{orderlist.item.shipping_address.houseNumberAssition}}<br></span>
                <span v-if="globals.otherOrderForAddress == 'true'">{{orderlist.item.shipping_address.houseNumber}} {{orderlist.item.shipping_address.houseNumberAssition}} {{orderlist.item.shipping_address.street}}<br></span>
                <span>{{orderlist.item.shipping_address.postcode}} {{orderlist.item.shipping_address.city}} {{orderlist.item.shipping_address.countryCode}}</span><br>
              </div>
            </div>
            <div class="content__billing_address content__box" v-if="orderlist.item.billing_address">
              <div class="content__header">
                <span class="heading delta">{{ $t('billingHeadline') }}</span>
              </div>
              <div class="content__line">
                <span>{{orderlist.item.billing_address.firstName}} {{orderlist.item.billing_address.lastName}}</span><br>
                <span v-if="globals.otherOrderForAddress == 'false'">{{orderlist.item.billing_address.street}} {{orderlist.item.billing_address.houseNumber}} {{orderlist.item.billing_address.houseNumberAssition}}<br></span>
                <span v-if="globals.otherOrderForAddress == 'true'">{{orderlist.item.billing_address.houseNumber}} {{orderlist.item.billing_address.houseNumberAssition}} {{orderlist.item.billing_address.street}}<br></span>
                <span>{{orderlist.item.billing_address.postcode}} {{orderlist.item.billing_address.city}} {{orderlist.item.billing_address.countryCode}}</span><br>
              </div>
            </div>
          </div>
          <div class="content__items">
            <div class="item_header">
              <div class="header__label">
                <span>{{ $t('name') }}</span>
              </div>
              <div class="header__label">
                <span>{{ $t('quantity') }}</span>
              </div>
              <div class="header__label">
                <span>{{ $t('unitprice') }}</span>
              </div>
              <div class="header__label">
                <span>{{ $t('total') }}</span>
              </div>
            </div>
            <div class="item__item" v-for="(element, index) in orderlist.item.items" :key="index">
              <div class="item__value">
                <span class="bold">{{element.name}}</span>
              </div>
              <div class="item__value">
                <span>{{element.quantity}}</span>
              </div>
              <div class="item__value">
                <span>{{$n(element.unitPrice, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
              </div>
              <div class="item__value" v-if="element.lineTotalDiscounted <= 0">
                <span class="icon-present"></span>
              </div>
              <div class="item__value" v-else-if="element.lineTotalDiscounted < element.lineTotal">
                <span class="-color-alpha -strikethrough">{{$n(element.lineTotal, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
                <span>{{$n(element.lineTotalDiscounted, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
              </div>
              <div class="item__value" v-else>
                <span>{{$n(element.lineTotal, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
              </div>
            </div>
          </div>
          <div class="payment-wrapper">
            <div class="content__payment content__box" v-if="orderlist.item.payment">
              <div class="content__header">
                <span class="heading delta">{{ $t('paymentHeadline') }}</span>
              </div>
              <div class="content__line">
                <span class="bold">{{ $t('paymentMethod') }}: </span><span> {{orderlist.item.payment.name}}</span><br>
              </div>
              <div class="content__line">
                <span class="bold">{{ $t('shippingMethod') }}: </span> <span>{{orderlist.item.shipping.name}}</span><br>
              </div>
            </div>
            <div class="content__price content__box">
              <div class="price__items">
                <div class="price__value">
                  <span>{{ $t('subtotal') }}: </span>
                  <span>{{$n(orderlist.item.itemsTotal, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
                </div>
                <div class="price__value">
                  <span>{{ $t('shipping') }}: </span>
                  <span>{{$n(orderlist.item.shippingTotal, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
                </div>
                <div class="price__value">
                  <span>{{ $t('tax') }}: </span>
                  <span>{{$n(orderlist.item.taxTotal, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
                </div>
                <div class="price__value">
                  <span class="bold">{{ $t('total') }}: </span>
                  <span class="bold">{{$n(orderlist.item.total, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
                </div>
                <div class="price__value" v-if="orderlist.item.promotionTotal > 0">
                  <span><span class="discount-icon"></span>{{ $t('discount') }}: </span>
                  <span>{{$n(orderlist.item.promotionTotal, orderlist.item.order_currency, orderlist.item.order_locale)}}</span>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { useGlobalStore } from '@/store'
import { useOrderlistStore } from '@/store/orderlist'
import {watch} from 'vue';

const globals = useGlobalStore()
const orderlist = useOrderlistStore()

globals.init()

function $n (total, curreny, locale)
{
  const currency = curreny ? curreny : 'EUR'
  const currencyLocale = locale ? locale.replace('_', '-') : 'de-DE'
  const number = total / 100
  return new Intl.NumberFormat(currencyLocale, {
    style: 'currency', currency
  }).format(number)
}

function openDetail(el)
{
  orderlist.getOrderItem(el)
}

watch(() => globals.showOverlay, () =>
{
  if (globals.showOverlay)
  {
    document.getElementsByTagName('html')[0].classList.add('-overlay-open')
  } else {
    document.getElementsByTagName('html')[0].classList.remove('-overlay-open')
  }
})

</script>

